import React from "react";
import Container from 'react-bootstrap/Container';
import { Outlet } from 'react-router-dom';
import { Header, SubHeader } from '../layout';


function AppLayout() {
    return (
        <Container className="px-0" fluid>
             <Header></Header>
             <SubHeader></SubHeader>
             <Outlet />
        </Container>                    
    );
}

export default AppLayout;